import api from "../api/axios";
import {
  AuthUser,
  LoginForm,
  PasswordResetRequestForm,
  ResetPasswordForm,
  SignUpForm,
  UpdateProfile,
  UserRespose,
  VerifyOtpForm,
} from "./auth.types";

export const signup = async (payload: SignUpForm): Promise<UserRespose> => {
  try {
    const response = await api.post(`/auth/signup`, payload);
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error during signup process",
    );
  }
};

export const login = async (payload: LoginForm): Promise<UserRespose> => {
  try {
    const response = await api.post(`/auth/login`, payload);
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error during login process",
    );
  }
};

export const requestPasswordReset = async (
  payload: PasswordResetRequestForm,
) => {
  try {
    const response = await api.post(`/auth/forgot-password`, payload);
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error requesting password reset",
    );
  }
};

export const verifyEmail = async (payload: VerifyOtpForm) => {
  try {
    const response = await api.post(`/auth/verify-email`, payload);
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error verifying email OTP",
    );
  }
};

export const verifyResetOtp = async (payload: VerifyOtpForm) => {
  try {
    const response = await api.post(`/auth/verify-reset-otp`, payload);
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error verifying reset OTP",
    );
  }
};

export const resendOtp = async (email: string) => {
  try {
    const response = await api.post(`/auth/resend-otp`, { email });
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error || error.message || "Error resending OTP",
    );
  }
};

export const resetPassword = async (payload: ResetPasswordForm) => {
  try {
    const response = await api.post(`/auth/reset-password`, payload);
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error resetting password",
    );
  }
};

export const logout = async () => {
  try {
    const response = await api.post(`/auth/logout`);
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error || error.message || "Error logging out",
    );
  }
};

export const updateProfile = async (
  payload: UpdateProfile,
): Promise<AuthUser> => {
  try {
    const response = await api.put(`/auth/profile/update`, payload);
    return response.data.user;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error || error.message || "Error updating profile",
    );
  }
};
